import styled from 'styled-components'

export const GalleryContainer = styled.div<{ $height?: string }>`
  position: relative;
  width: 100%;
  height: ${({ $height }) => $height || '500px'};
  background: ${({ theme }) => theme.colors.background.tertiary};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 350px;
  }
`

export const GalleryWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const GalleryTrack = styled.div<{ $currentIndex: number }>`
  display: flex;
  height: 100%;
  transform: translateX(-${({ $currentIndex }) => $currentIndex * 100}%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`

export const GallerySlide = styled.div`
  min-width: 100%;
  height: 100%;
  position: relative;
`

export const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const ImageCounter = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing.medium};
  right: ${({ theme }) => theme.spacing.medium};
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  backdrop-filter: blur(10px);
`

export const GalleryControls = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spacing.large};
  pointer-events: none;
`

export const GalleryButton = styled.button`
  pointer-events: all;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  width: 48px;
  height: 48px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  box-shadow: ${({ theme }) => theme.shadows.md};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: white;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`

export const ThumbnailStrip = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: ${({ theme }) => theme.spacing.default};
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Thumbnail = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border: 2px solid ${({ $active }) => ($active ? 'white' : 'transparent')};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
  cursor: pointer;
  opacity: ${({ $active }) => ($active ? 1 : 0.7)};
  transition: all 0.2s;
  background: transparent;
  padding: 0;

  &:hover {
    opacity: 1;
    border-color: rgba(255, 255, 255, 0.5);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
